import { cn } from "@/lib/utils";

const LIGHT_BG_SRC = "/dental-flow-logo.png"; // dark "Flow" script — for light backgrounds
const DARK_BG_SRC = "/dental-flow-logo-dark.png"; // white "Flow" script — for dark backgrounds

interface DentalFlowLogoProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  /**
   * auto (default): follows the app theme via the `dark` class.
   * light/dark: force the variant for surfaces with a fixed background
   * (e.g. the landing footer is always #020617 even in light mode).
   */
  variant?: "auto" | "light" | "dark";
}

export const DentalFlowLogo = ({
  size = "md",
  className,
  variant = "auto"
}: DentalFlowLogoProps) => {
  const sizeMap = {
    sm: "h-6",
    md: "h-10",
    lg: "h-16",
    xl: "h-24"
  };

  const imgClass = cn(sizeMap[size], "w-auto object-contain", className);

  if (variant === "light") {
    return <img src={LIGHT_BG_SRC} alt="Dental Flow Logo" className={imgClass} />;
  }
  if (variant === "dark") {
    return <img src={DARK_BG_SRC} alt="Dental Flow Logo" className={imgClass} />;
  }

  // Theme-aware: CSS-only swap avoids next-themes hydration flicker
  return (
    <>
      <img src={LIGHT_BG_SRC} alt="Dental Flow Logo" className={cn(imgClass, "dark:hidden")} />
      <img src={DARK_BG_SRC} alt="Dental Flow Logo" className={cn(imgClass, "hidden dark:block")} />
    </>
  );
};

// Keep backward compatibility alias
export const ClinicFlowLogo = DentalFlowLogo;
